// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ClientesLookupInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /customer-portal/v1/clientes/lookup
 *
 * The body-based replacement for `GET /clientes?documento=`. A POST for a read
 * is deliberate, and for two reasons that both bite the query-string form:
 *
 *   1. The edge proxy logs raw request URIs, so a document in a query string
 *      lands in the access log in plaintext (ADR-0014 §4 — the same reason the
 *      portal's own lookup is `POST /accounts/lookup` rather than a GET by path).
 *   2. ADR-0014's canonical signing string covers method, path, body hash and
 *      timestamp — **not the query string**. A document carried in the query is
 *      therefore outside the signature entirely, so the HMAC cannot detect it
 *      being altered in transit. Moving it into the body brings it under the
 *      signature for free.
 *
 * The field is `document` (English, ADR-0014 §3), not `documento`: the GET form
 * predates that rule and keeps its Portuguese parameter until it is retired.
 *
 * Emptiness is NOT validated here — it is checked after normalization in the
 * controller, because a body of `{"document": "..."}` normalizes to '' and the
 * contract layer cannot express "empty once punctuation is stripped".
 */
import { registerContract } from './validate'

export interface Portal_ClientesLookupInput {
document: string
}

registerContract('Portal_ClientesLookupInput', {
  document: { type: 'string',  required: true },
})
